'use strict';

var enumerate = require('../../lib/enumerate');

module.exports = enumerate([
  'AUTHENTICATION_COMPLETE'
], 'threedsecure:');



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/three-d-secure/shared/events.js
// module id = 378
// module chunks = 0